import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { useAppSelector } from '../../../redux/store';

import { fetchSingleAdminUser } from '@actions/adminUsers/fetchSingleAdminUser';
import {
    getAdminUser,
    // getAdminUsersError
} from '@selectors/adminUsers';

import AdminUser from './AdminUser';

import UpdateAdminPasswordModal from './UpdateAdminPasswordModal';
import DeleteAdminModal from './DeleteAdminModal';
import UpdateAdminModal from '../adminUsers/UpdateAdminModal';

const AdminUserContainer: React.FC = () => {
    const dispatch = useDispatch();
    const { id, action } = useParams<{ id: string; action?: string }>();

    useEffect(() => {
        dispatch(fetchSingleAdminUser(+id));
    }, [id, dispatch]);

    // const error = useSelector(getAdminUsersError);
    const user = useAppSelector(state => getAdminUser(state, +id));
    const history = useHistory();
    const closeModal = useCallback(() => {
        history.replace(`/admins/${id}`);
    }, [history, id]);

    return (
        <>
            <AdminUser user={user} />
            {action === 'delete' && <DeleteAdminModal user={user} />}
            {!!user && action === 'edit-password' && <UpdateAdminPasswordModal user={user} />}
            {!!user && action === 'edit' && (
                <UpdateAdminModal user={user} closeModal={closeModal} />
            )}
        </>
    );
};

export default AdminUserContainer;
